import { stripTags } from '../utils/general'

// Define isDomain function locally if import is failing
const isDomain = (url) => {
  // Simple domain check - adjust logic as needed
  return url && !url.startsWith('http') && !url.includes('/')
}
import Slider from 'react-slick';
import Image from 'next/image'
import Link from 'next/link'
import { ProgressBar, Button } from 'react-bootstrap'
import { useState, useEffect, useRef } from 'react'
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton,
         FacebookIcon, TwitterIcon, LinkedinIcon,EmailIcon} from 'react-share'
import { FaStar, FaShareAlt, FaCheck } from 'react-icons/fa'
import { isMobile } from "react-device-detect";
import styles from './dashboard.module.css'
import params from '../data/params' 
import sections from '../data/sections' 

export default function CarouselWrapper({ site, contents, watched }) {

  const [slideIndex, setSlideIndex] = useState(0);
  const [slideBreakpoint, setSlideBreakpoint] = useState(5);
  const [hovered, setHovered] = useState(false);
  
  // Use refs to store per-item state to avoid React batching issues
  const socialStates = useRef({});
  const copyStates = useRef({});
  const [, forceUpdate] = useState({});
  
  // Force component re-render
  const triggerRerender = () => forceUpdate({});
  
  const toggleHover = () => setHovered(!hovered);

  // Initialize states for new items
  const initializeItemState = (idx) => {
    if (!(idx in socialStates.current)) {
      socialStates.current[idx] = false;
    }
    if (!(idx in copyStates.current)) {
      copyStates.current[idx] = false;
    }
  };

  // Toggle social sharing for specific item
  const toggleSocial = (idx) => {
    initializeItemState(idx);
    socialStates.current[idx] = !socialStates.current[idx];
    triggerRerender();
  };

  // Handle copy functionality for specific item
  const copyToClipboard = async (text, idx) => {
    initializeItemState(idx);
    
    try {
      await navigator.clipboard.writeText(text);
      copyStates.current[idx] = true;
      triggerRerender();
      
      // Reset after 2 seconds
      setTimeout(() => {
        copyStates.current[idx] = false;
        triggerRerender();
      }, 2000);
      
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
        copyStates.current[idx] = true;
        triggerRerender();
        
        // Reset after 2 seconds
        setTimeout(() => {
          copyStates.current[idx] = false;
          triggerRerender();
        }, 2000);
        
      } catch (fallbackErr) {
        console.log('Copy failed:', fallbackErr);
      }
      
      document.body.removeChild(textArea);
    }
  };

  useEffect(() => {
    function handleResize() {
      const { innerWidth: width, innerHeight: height } = window;

      if(width >= 1100) {
        setSlideBreakpoint(4)
      }
      else if (width <= 1099 && width >= 800) {
        setSlideBreakpoint(3)
      }
      else if (width <= 799 && width >= 767) {
        setSlideBreakpoint(2)
      }
      else if (width >= 766) {
        setSlideBreakpoint(1)
      }
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, );

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 1099,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 799,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          dots: false
        }
      },
    ]
  }

  return (
    <div className={`${hovered ? 'zindex-3' : ''} slides position-relative`}>
      <Slider {...settings} beforeChange={(current, next) => {setSlideIndex(next);}}>
        {contents.map(function(content, idx) {
          const section = sections.filter((e) => e.id == content.type)
          const url =  "/a/" + content.slug

          // FIXED: Function to remove www. from domain to avoid SSL certificate issues
          const getDomainWithoutWww = (url) => {
            if (!url) return '';
            
            // Remove protocol if present
            let cleanUrl = url.replace(/^https?:\/\//, '');
            
            // Remove any existing www. prefix
            cleanUrl = cleanUrl.replace(/^www\./, '');
            
            // Return clean URL without www.
            return cleanUrl;
          };
          
          const domain = getDomainWithoutWww(site.url);
           
          // FIXED: Detect localhost and use appropriate protocol
          const isLocalhost = typeof window !== 'undefined' && 
            (window.location.hostname === 'localhost' || 
             window.location.hostname.includes('.local') ||
             window.location.hostname === '127.0.0.1');

          const shareUrl = isLocalhost 
            ? `${window.location.protocol}//${window.location.host}${url}?source=share`
            : `https://${domain}${url}?source=share`;
          
          const image = content.theThumbnail ? content.theThumbnail : params.noimage

          const theObject = content.watched_data ? JSON.parse(content.watched_data) : '';
          const percentage = theObject ? (theObject.percentage == 99 ? parseInt(theObject.percentage) + 1 : theObject.percentage) : 0

          // Initialize states for this item
          initializeItemState(idx);
          const isShowingSocial = socialStates.current[idx] || false;
          const isCopied = copyStates.current[idx] || false;

          return (
            <div key={idx}  id={`card${idx}`} className={`cardContainer ${idx === slideIndex ? "first" : idx === slideIndex + slideBreakpoint ? "last" : ""} `} onMouseOver={toggleHover} onMouseOut={toggleHover} >
            {
                watched && content.is_watched == 1 && (percentage > 0 && percentage < 100)  ? 
            
                <div className="cardSlider">
                    { isMobile === true ? <img width={286} height={150} src ={image}  className="img-fluid"/> : <Link href={url} ><a><img width={286} height={150} src ={image} className="img-fluid"/></a></Link> }
                    <div className="mt-1 pbar"> 
                      {
                        content.is_read == 1 ? <p className=" mb-0 read h8 text-right position-relative"><FaCheck className="cardCheck"/> Finished</p> : ''
                      }

                      {
                        content.is_downloaded == 1 ? <p className="read h8 text-right position-relative"><FaCheck className="cardCheck"/> Downloaded</p> : ''
                      }

                      {
                        content.is_watched == 1 ? <ProgressBar now={percentage}/> : ''
                      }
                    </div>
                    
                    <div className={`${styles.cardItem} d-none cardDetails position-relative  mt-n2 p-2 pb-3 text-white `} >
                      <Link href={ url }>
                        <a className="text-reset text-decoration-none">
                          <p className="h9 text-left">
                            <span className="cat-cw">Category:</span> { site.site.code == "BC" && content.type == 4 ? content.category.parent.short_name : content.category.short_name }
                            <br className="d-sm-none"/>
                            <span className="cat-cw ml-lg-5 ml-sm-3">Section:</span> {content.typeLabel}
                          </p>
                        </a>
                      </Link>
                      <Link href={ url } >  
                        <a className={`${styles.cardLink} d-flex text-white d-block mb-3`} key={idx}>
                          {section.length ? <Image width={25}  height={20} src={section[0].icon} /> : "" }
                          <p className={`${styles.cardWidth} h9 text-left ml-3 mb-0`}>
                              <span className="mb-0">{content.title} <br/> {content.tagline} </span>
                          </p>
                        </a>
                      </Link>
                      <div className="d-flex h9 justify-content-between">
                        <span><FaStar className="text-warning"/> Value: {params.points[content.type]} pts. </span>
                        <span onClick={() => toggleSocial(idx)}>Share <FaShareAlt/></span>
                        {
                          content.is_read == 1 ? <span className="h9"><FaCheck className="cardCheck"/> Finished</span> : ''
                        }

                        {
                          content.is_downloaded == 1 ? <span className="h9"><FaCheck className="cardCheck"/>  Downloaded</span> : ''
                        }

                        {
                          content.is_watched == 1 ? <span className="h9">{"Watched "+percentage+"%"} </span> : ''
                        }
                      </div>
                      {isShowingSocial && 
                        <div>
                            <input value={shareUrl} readOnly className="border-0 bg-transparent h9 text-white w-100"/>
                            <div className="d-sm-flex align-items-end">
                              <Button 
                                onClick={() => copyToClipboard(shareUrl, idx)} 
                                className="bg-transparent py-1 px-2 h9"
                                disabled={isCopied}
                              >
                                {isCopied ? 'Copied' : 'Copy Link'}
                              </Button>
                              <div className="ml-auto">
                                <FacebookShareButton  url={shareUrl} quote={content.title} className="mx-1 mt-2"> <FacebookIcon  size={"1.5rem"} round/> </FacebookShareButton>
                                <TwitterShareButton url={shareUrl} quote={content.title} hashtags={['yourwellnessproject', 'hello']} className="mx-1 mt-2"> <TwitterIcon  size={"1.5rem"} round/> </TwitterShareButton>
                                <LinkedinShareButton url={shareUrl} source={shareUrl} title={content.title} summary={stripTags(content.theExcerpt)} className="mx-1 mt-2"> <LinkedinIcon  size={"1.5rem"} round/> </LinkedinShareButton>
                                <EmailShareButton url={shareUrl} quote={content.title} subject="Your Wellness" className="mx-1 mt-2"> <EmailIcon  size={"1.5rem"} round/> </EmailShareButton>
                              </div>
                            </div>
                        </div>
                      }
                    </div>
                    
                  </div>
                : 

                <div className="cardSlider">
                    { isMobile === true ? <img width={286} height={150} src ={image}  className="img-fluid"/> : <Link href={url} ><a><img width={286} height={150} src ={image} className="img-fluid"/></a></Link> }
                    <div className="mt-1 pbar"> 
                      {
                        content.is_read == 1 ? <p className=" mb-0 read h8 text-right position-relative"><FaCheck className="cardCheck"/> Finished</p> : ''
                      }

                      {
                        content.is_downloaded == 1 ? <p className="read h8 text-right position-relative"><FaCheck className="cardCheck"/> Downloaded</p> : ''
                      }

                      {
                        content.is_watched == 1 ? <ProgressBar now={percentage}/> : ''
                      }
                    </div>
                    
                    <div className={`${styles.cardItem} d-none cardDetails position-relative  mt-n2 p-2 pb-3 text-white `} >
                      <Link href={ url }>
                        <a className="text-reset text-decoration-none">
                          <p className="h9 text-left">
                            <span className="cat-cw">Category:</span> { site.site.code == "BC" && content.type == 4 ? content.category.parent.short_name : content.category.short_name }
                            <br className="d-sm-none"/>
                            <span className="cat-cw ml-lg-5 ml-sm-3">Section:</span> {content.typeLabel}
                          </p>
                        </a>
                      </Link>
                      <Link href={ url } >  
                        <a className={`${styles.cardLink} d-flex text-white d-block mb-3`} key={idx}>
                          {section.length ? <Image width={25}  height={20} src={section[0].icon} /> : "" }
                          <p className={`${styles.cardWidth} h9 text-left ml-3 mb-0`}>
                              <span className="mb-0">{content.title} <br/> {content.tagline} </span>
                          </p>
                        </a>
                      </Link>
                      <div className="d-flex h9 justify-content-between">
                        <span><FaStar className="text-warning"/> Value: {params.points[content.type]} pts. </span>
                        <span onClick={() => toggleSocial(idx)}>Share <FaShareAlt/></span>
                        {
                          content.is_read == 1 ? <span className="h9"><FaCheck className="cardCheck"/> Finished</span> : ''
                        }

                        {
                          content.is_downloaded == 1 ? <span className="h9"><FaCheck className="cardCheck"/>  Downloaded</span> : ''
                        }

                        {
                          content.is_watched == 1 ? <span className="h9">{"Watched "+percentage+"%"} </span> : ''
                        }
                      </div>
                      {isShowingSocial && 
                        <div>
                            <input value={shareUrl} readOnly className="border-0 bg-transparent h9 text-white w-100"/>
                            <div className="d-sm-flex align-items-end">
                              <Button 
                                onClick={() => copyToClipboard(shareUrl, idx)} 
                                className="bg-transparent py-1 px-2 h9"
                                disabled={isCopied}
                              >
                                {isCopied ? 'Copied' : 'Copy Link'}
                              </Button>
                              <div className="ml-auto">
                                <FacebookShareButton  url={shareUrl} quote={content.title} className="mx-1 mt-2"> <FacebookIcon  size={"1.5rem"} round/> </FacebookShareButton>
                                <TwitterShareButton url={shareUrl} quote={content.title} hashtags={['yourwellnessproject', 'hello']} className="mx-1 mt-2"> <TwitterIcon  size={"1.5rem"} round/> </TwitterShareButton>
                                <LinkedinShareButton url={shareUrl} source={shareUrl} title={content.title} summary={stripTags(content.theExcerpt)} className="mx-1 mt-2"> <LinkedinIcon  size={"1.5rem"} round/> </LinkedinShareButton>
                                <EmailShareButton url={shareUrl} quote={content.title} subject="Your Wellness" className="mx-1 mt-2"> <EmailIcon  size={"1.5rem"} round/> </EmailShareButton>
                              </div>
                            </div>
                        </div>
                      }
                    </div>
                    
                </div>
            }
            </div>

          );
          })}
      </Slider >
     
    </div>
  );
}